:host {
  display: none;
  width: 100%;
  height: 100%;
  background-color: var(--white-layout-302-level-1-elevation);
}

:host([data-is-visible]) {
  display: block;
}

.form-section {
  width: 100%;
  height: auto;
  margin-bottom: calc(4 * var(--spacer));
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

gz-labeled-content {
  margin-top: var(--spacer);
  margin-bottom: var(--spacer);

  gz-text {
    line-height: 1.25;
  }

  gz-link {
    --wrapper-padding: 0;
  }
}

.hidden {
  display: none;
}

.form-field {
  margin-top: var(--spacer);
  margin-bottom: var(--spacer);
}

#general-title-section {
  display: flex;
  align-items: center;
}

#general-title {
  width: auto;
  margin-right: calc(2 * var(--spacer));
  padding-right: calc(2 * var(--spacer));
  border-right: 1px solid var(--chart-101-pressed-dividers);
}

#learn-more {
  width: 120px;
}
